import { SYNC_ERROR_CODES } from './constants';
import { fetchImplementationStatus } from './connectorApi';
import {
    mapCreateImplementationError,
    mapImplementationStatusResponse,
} from './mapCreateImplementation';

const POLL_INTERVAL_MS = 2500;
const POLL_TIMEOUT_MS = 5 * 60 * 1000;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const pollImplementationStatus = async (tag) => {
    const startedAt = Date.now();

    while (Date.now() - startedAt < POLL_TIMEOUT_MS) {
        try {
            const { data } = await fetchImplementationStatus(tag);
            const status = mapImplementationStatusResponse(data);

            if (status.complete) {
                const url = typeof status.url === 'string' ? status.url.trim() : '';
                if (!url) {
                    return { success: false, errorCode: SYNC_ERROR_CODES.CREATE_FAILED };
                }
                return { success: true, redirectUrl: url };
            }

            if (status.failed) {
                return {
                    success: false,
                    errorCode: SYNC_ERROR_CODES.CREATE_FAILED,
                    error: status.error,
                };
            }
        } catch (error) {
            return mapCreateImplementationError(error);
        }

        await delay(POLL_INTERVAL_MS);
    }

    return { success: false, errorCode: SYNC_ERROR_CODES.CREATE_TIMEOUT };
};
